import {BiFolder, BiWrench, BiSearchAlt2} from 'react-icons/bi';
import {MenuItem} from './MenuItem';
import {FormattedMessage} from 'react-intl';
import {ReactNode} from 'react';
import {Logo} from '../../icons/Logo';

type Props = {
  children: ReactNode;
};

type ItemProps = {
  isListItem?: boolean;
  hideLabel?: boolean;
};

type InboxItemProps = ItemProps & {messageCount: number};

type AccountsItemProps = ItemProps & {numberOfApplications: number};

function Item(props: Props) {
  return <div>{props.children}</div>;
}

function HomeButton({isAuthenticated}: {isAuthenticated: boolean}) {
  return (
    <Logo
      displayFlagOnlyOnSmallScreens={isAuthenticated}
      className={`${isAuthenticated ? 'w-[5.275rem]' : 'w-56'} md:w-48 md:ml-2 lg:ml-0`}
    />
  );
}

function MenuButton({open}: {open: boolean}) {
  return (
    <MenuItem isListItem>
      <div className="block h-4 w-5 hover:cursor-pointer relative">
        <div
          className={`${
            open ? 'rotate-45 mt-0' : '-mt-1.5'
          } rounded-full absolute h-0.5 w-full top-2/4  bg-brage-black duration-500 -translate-y-2/4`}
        ></div>
        <div
          className={`${
            open ? 'scale-x-0' : 'scale-x-100'
          } rounded-full absolute h-0.5 w-full top-2/4  bg-brage-black duration-500 -translate-y-2/4`}
        ></div>
        <div
          className={`${
            open ? '-rotate-45 mt-0' : 'mt-1.5'
          } rounded-full absolute h-0.5 w-full top-2/4 bg-brage-black duration-500 -translate-y-2/4`}
        ></div>
      </div>
    </MenuItem>
  );
}

function Admin({isListItem}: ItemProps) {
  return (
    <MenuItem isListItem={isListItem}>
      <MenuItem.Icon>
        <BiWrench />
      </MenuItem.Icon>
      <MenuItem.Label>
        <FormattedMessage id="MenuItem.Admin" />
      </MenuItem.Label>
    </MenuItem>
  );
}

function Archive({isListItem}: ItemProps) {
  return (
    <MenuItem isListItem={isListItem}>
      <MenuItem.Icon>
        <BiFolder />
      </MenuItem.Icon>
      <MenuItem.Label>
        <FormattedMessage id="MenuItem.Archive" />
      </MenuItem.Label>
    </MenuItem>
  );
}

function Invoice({isListItem, hideLabel}: ItemProps) {
  return (
    <MenuItem isListItem={isListItem}>
      <MenuItem.Icon className="relative">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M2.16666 13.3335V2.6665C2.16674 2.18039 2.36003 1.71435 2.70377 1.37061C3.04751 1.02687 3.51355 0.833582 3.99966 0.833496H9.33365L9.4313 0.843262C9.52741 0.862472 9.61684 0.909653 9.68716 0.97998L13.6872 4.97998C13.7808 5.07373 13.8336 5.20096 13.8336 5.3335V13.3335C13.8336 13.8196 13.6402 14.2856 13.2965 14.6294C12.9527 14.9732 12.4859 15.1665 11.9997 15.1665H3.99966C3.51355 15.1664 3.04751 14.9731 2.70377 14.6294C2.36005 14.2856 2.16666 13.8196 2.16666 13.3335ZM3.16666 13.3335C3.16666 13.5544 3.25462 13.7661 3.4108 13.9224C3.567 14.0786 3.77877 14.1664 3.99966 14.1665H11.9997C12.2207 14.1665 12.4332 14.0786 12.5895 13.9224C12.7456 13.7661 12.8336 13.5544 12.8336 13.3335V5.54053L9.12662 1.8335H3.99966C3.77877 1.83358 3.567 1.92143 3.4108 2.07764C3.25459 2.23384 3.16674 2.44561 3.16666 2.6665V13.3335Z"
            fill="#00002B"
          />
          <path
            d="M8.83332 1.3335C8.83332 1.05735 9.05751 0.833496 9.33365 0.833496C9.60979 0.833496 9.83332 1.05735 9.83332 1.3335V4.8335H13.3333L13.4339 4.84326C13.6619 4.88979 13.8336 5.09178 13.8336 5.3335C13.8336 5.57521 13.6619 5.7772 13.4339 5.82373L13.3333 5.8335H9.33332C9.05718 5.8335 8.83332 5.60964 8.83332 5.3335V1.3335Z"
            fill="#00002B"
          />
          <path
            d="M10.6663 8.16683L10.7679 8.1766C10.9955 8.22336 11.1663 8.42534 11.1663 8.66683C11.1663 8.90832 10.9955 9.1103 10.7679 9.15706L10.6663 9.16683H5.33332C5.05718 9.16683 4.83332 8.94297 4.83332 8.66683C4.83332 8.39069 5.05718 8.16683 5.33332 8.16683H10.6663Z"
            fill="#00002B"
          />
          <path
            d="M10.6663 10.8335L10.7679 10.8433C10.9955 10.89 11.1663 11.092 11.1663 11.3335C11.1663 11.575 10.9955 11.777 10.7679 11.8237L10.6663 11.8335H5.33332C5.05718 11.8335 4.83332 11.6096 4.83332 11.3335C4.83332 11.0574 5.05718 10.8335 5.33332 10.8335H10.6663Z"
            fill="#00002B"
          />
          <path
            d="M6.66633 5.50016L6.76789 5.50993C6.99555 5.55669 7.16633 5.75867 7.16633 6.00016C7.16633 6.24166 6.99555 6.44363 6.76789 6.4904L6.66633 6.50016H5.33332C5.05718 6.50016 4.83332 6.27631 4.83332 6.00016C4.83332 5.72402 5.05718 5.50016 5.33332 5.50016H6.66633Z"
            fill="#00002B"
          />
        </svg>
      </MenuItem.Icon>
      {!hideLabel && (
        <MenuItem.Label>
          <FormattedMessage id="MenuItem.Invoice" />
        </MenuItem.Label>
      )}
    </MenuItem>
  );
}

function Search({isListItem, hideLabel}: ItemProps) {
  return (
    <MenuItem isListItem={isListItem}>
      <MenuItem.Icon>
        <BiSearchAlt2 />
      </MenuItem.Icon>
      {!hideLabel && (
        <MenuItem.Label>
          <FormattedMessage id="MenuItem.Search" />
        </MenuItem.Label>
      )}
    </MenuItem>
  );
}

function Inbox({isListItem, messageCount}: InboxItemProps) {
  return (
    <MenuItem isListItem={isListItem}>
      <MenuItem.Icon className="relative">
        <MenuItem.New value={messageCount} />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M5.33334 7.50002C5.50052 7.50002 5.65663 7.58358 5.74936 7.72268L6.93425 9.50002H9.06576L10.2507 7.72268L10.2884 7.6732C10.3827 7.56405 10.5204 7.50002 10.6667 7.50002H14.6667C14.9428 7.50002 15.1667 7.72388 15.1667 8.00002C15.1667 8.27616 14.9428 8.50002 14.6667 8.50002H10.9343L9.74936 10.2774C9.65663 10.4165 9.50052 10.5 9.33334 10.5H6.66668C6.4995 10.5 6.34339 10.4165 6.25066 10.2774L5.06576 8.50002H1.33334C1.0572 8.50002 0.833344 8.27616 0.833344 8.00002C0.833344 7.72388 1.0572 7.50002 1.33334 7.50002H5.33334Z"
            fill="#00002B"
          />
          <path
            d="M14.1667 8.11851L11.9186 3.62893C11.8496 3.49026 11.7436 3.37333 11.612 3.29169C11.5131 3.23039 11.4028 3.19054 11.2884 3.1745L11.1732 3.16669H4.82683C4.67184 3.16679 4.51976 3.21 4.38803 3.29169C4.25641 3.37333 4.15037 3.49026 4.08139 3.62893L4.08074 3.63088L4.08009 3.63023L1.83334 8.11851V12C1.83334 12.221 1.9212 12.4329 2.07748 12.5892C2.23376 12.7455 2.44566 12.8334 2.66668 12.8334H13.3333C13.5544 12.8334 13.7663 12.7455 13.9225 12.5892C14.0788 12.4329 14.1667 12.221 14.1667 12V8.11851ZM15.1667 12C15.1667 12.4863 14.9734 12.9524 14.6296 13.2962C14.2858 13.6401 13.8196 13.8334 13.3333 13.8334H2.66668C2.18045 13.8334 1.71427 13.6401 1.37045 13.2962C1.02664 12.9524 0.833344 12.4863 0.833344 12V8.00002C0.833344 7.9223 0.85128 7.84556 0.886078 7.77606L3.18621 3.18296C3.338 2.87806 3.57186 2.62159 3.86134 2.44208C4.15113 2.26238 4.4852 2.16691 4.82618 2.16669H11.1738L11.3014 2.17124C11.5978 2.19211 11.8851 2.28487 12.1387 2.44208C12.4282 2.62159 12.662 2.87806 12.8138 3.18296L15.1139 7.77606C15.1487 7.84556 15.1667 7.9223 15.1667 8.00002V12Z"
            fill="#00002B"
          />
        </svg>
      </MenuItem.Icon>
      <MenuItem.Label>
        <FormattedMessage id="MenuItem.Inbox" />
      </MenuItem.Label>
    </MenuItem>
  );
}

function Settings({isListItem}: ItemProps) {
  return (
    <MenuItem isListItem={isListItem}>
      <MenuItem.Icon>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clip-path="url(#clip0_3374_397)">
            <path
              d="M9.49999 8.00002C9.49999 7.17159 8.82842 6.50002 7.99999 6.50002C7.17156 6.50002 6.49999 7.17159 6.49999 8.00002C6.49999 8.82845 7.17156 9.50002 7.99999 9.50002C8.82842 9.50002 9.49999 8.82845 9.49999 8.00002ZM10.5 8.00002C10.5 9.38073 9.3807 10.5 7.99999 10.5C6.61928 10.5 5.49999 9.38073 5.49999 8.00002C5.49999 6.61931 6.61928 5.50002 7.99999 5.50002C9.3807 5.50002 10.5 6.61931 10.5 8.00002Z"
              fill="#00002B"
            />
            <path
              d="M8.83332 2.00002C8.83332 1.77901 8.74546 1.56711 8.58918 1.41083C8.4329 1.25455 8.221 1.16669 7.99999 1.16669C7.77898 1.16669 7.56708 1.25455 7.4108 1.41083C7.25452 1.56711 7.16666 1.77901 7.16666 2.00002V2.11525C7.16541 2.42729 7.07267 2.73205 6.90038 2.99221C6.72815 3.25228 6.48393 3.45651 6.19726 3.57945C6.15004 3.59968 6.09975 3.61221 6.04882 3.61721C5.78327 3.7137 5.49605 3.73881 5.21679 3.68817C4.90231 3.6311 4.61193 3.48068 4.38345 3.25718L4.33983 3.21356C4.26244 3.13608 4.17017 3.07451 4.069 3.03257C3.96785 2.99065 3.85948 2.96877 3.74999 2.96877C3.6405 2.96877 3.53213 2.99065 3.43098 3.03257C3.35519 3.06399 3.28453 3.10636 3.22134 3.15822L3.16015 3.21356C3.08267 3.29096 3.02109 3.38323 2.97916 3.4844C2.93725 3.58552 2.91535 3.69394 2.91535 3.80341C2.91536 3.91289 2.93724 4.02128 2.97916 4.12242C3.02109 4.22358 3.08267 4.31586 3.16015 4.39325L3.20051 4.43296L3.20442 4.43687C3.42792 4.66536 3.57769 4.95571 3.63476 5.2702C3.69149 5.58312 3.6535 5.90601 3.52603 6.19729C3.41356 6.48809 3.21876 6.74028 2.96483 6.9219C2.70375 7.10856 2.39247 7.21257 2.0716 7.22007H1.99999C1.77898 7.22007 1.56708 7.30793 1.4108 7.46421C1.25453 7.62049 1.16666 7.8324 1.16666 8.05341C1.16667 8.2744 1.25453 8.48633 1.4108 8.6426C1.56708 8.79886 1.77899 8.88674 1.99999 8.88674H2.11522C2.42715 8.88798 2.73208 8.98019 2.99218 9.15236C3.25088 9.32369 3.45433 9.56685 3.57746 9.85158L3.62173 9.96226C3.71486 10.2247 3.73806 10.5079 3.68814 10.7832C3.63107 11.0977 3.48065 11.3881 3.25715 11.6166L3.21353 11.6602C3.13605 11.7376 3.07448 11.8298 3.03254 11.931C2.99062 12.0322 2.96874 12.1405 2.96874 12.25L2.97265 12.3321C2.98069 12.4134 3.00113 12.4932 3.03254 12.569C3.07448 12.6702 3.13605 12.7625 3.21353 12.8399L3.27473 12.8952C3.33791 12.947 3.40859 12.9894 3.48436 13.0209C3.58549 13.0628 3.69391 13.0847 3.80338 13.0847C3.91286 13.0846 4.02125 13.0628 4.12239 13.0209C4.22355 12.9789 4.31583 12.9173 4.39322 12.8399L4.43293 12.7995L4.43684 12.7956C4.66532 12.5721 4.95571 12.4223 5.27017 12.3653C5.58472 12.3082 5.90935 12.3469 6.20181 12.4759C6.49091 12.5886 6.7411 12.7824 6.92186 13.0352C7.10853 13.2963 7.21254 13.6075 7.22004 13.9284V14C7.22004 14.221 7.3079 14.4329 7.46418 14.5892C7.62046 14.7455 7.83237 14.8334 8.05338 14.8334C8.27437 14.8333 8.4863 14.7455 8.64257 14.5892C8.79883 14.4329 8.88671 14.221 8.88671 14V13.8848C8.88795 13.5729 8.98016 13.2679 9.15233 13.0078C9.32419 12.7483 9.56828 12.5443 9.85416 12.4212C10.1459 12.2931 10.4696 12.255 10.7832 12.3119C11.0584 12.3618 11.3151 12.4829 11.528 12.6621L11.6165 12.7429L11.6601 12.7865L11.7213 12.8418C11.7845 12.8937 11.8552 12.936 11.931 12.9675C12.0321 13.0094 12.1405 13.0313 12.25 13.0313C12.3595 13.0313 12.4679 13.0094 12.569 12.9675C12.6702 12.9255 12.7624 12.864 12.8398 12.7865L12.8952 12.7253C12.947 12.6621 12.9894 12.5914 13.0208 12.5156C13.0627 12.4145 13.0846 12.3061 13.0846 12.1966C13.0846 12.0872 13.0627 11.9788 13.0208 11.8776C12.9894 11.8018 12.947 11.7312 12.8952 11.668L12.8398 11.6068L12.7995 11.5671L12.7956 11.5632C12.5723 11.3347 12.4223 11.0441 12.3652 10.7298C12.3082 10.4153 12.3468 10.0907 12.4759 9.7982C12.599 9.51349 12.8025 9.27094 13.0612 9.09963C13.3213 8.92736 13.6261 8.8346 13.9381 8.83335H14C14.221 8.83335 14.4329 8.74549 14.5892 8.58921C14.7455 8.43293 14.8333 8.22103 14.8333 8.00002C14.8333 7.77901 14.7455 7.56711 14.5892 7.41083C14.4329 7.25455 14.221 7.16669 14 7.16669H13.8848C13.5727 7.16544 13.268 7.0727 13.0078 6.90041C12.7477 6.72818 12.5435 6.48396 12.4206 6.19729C12.4003 6.15005 12.3871 6.0998 12.3822 6.04885C12.2857 5.78335 12.2612 5.49601 12.3118 5.21682C12.3689 4.90234 12.5193 4.61197 12.7428 4.38348L12.7864 4.33986L12.8418 4.27867C12.8937 4.21548 12.936 4.14482 12.9674 4.06903C13.0094 3.96788 13.0312 3.85951 13.0312 3.75002C13.0312 3.64053 13.0094 3.53216 12.9674 3.43101C12.936 3.35522 12.8937 3.28457 12.8418 3.22137L12.7864 3.16018C12.7091 3.0827 12.6168 3.02112 12.5156 2.97919C12.4145 2.93728 12.3061 2.91539 12.1966 2.91539C12.0871 2.91539 11.9787 2.93727 11.8776 2.97919C11.8018 3.01061 11.7312 3.05297 11.668 3.10484L11.6068 3.16018L11.567 3.20054L11.5631 3.20445L11.5625 3.2038C11.334 3.42726 11.0443 3.57773 10.7298 3.63479C10.4168 3.69154 10.0941 3.65296 9.80272 3.52541C9.80183 3.52503 9.80101 3.52514 9.80012 3.52476C9.79949 3.52448 9.79879 3.52438 9.79817 3.52411C9.51357 3.40096 9.27087 3.19743 9.0996 2.93882C8.92733 2.67867 8.83457 2.37389 8.83332 2.06187V2.00002ZM9.83332 2.05796L9.83983 2.1452C9.85281 2.23118 9.88457 2.31365 9.93293 2.38674C9.98135 2.45985 10.045 2.52154 10.1191 2.56708L10.1973 2.60744L10.2018 2.6094C10.3115 2.6578 10.4335 2.6718 10.5514 2.65041C10.6693 2.62898 10.7783 2.57272 10.8639 2.48895L10.8997 2.45315L11.0332 2.33205C11.1723 2.21784 11.3279 2.12453 11.4948 2.05536C11.7173 1.96315 11.9558 1.91539 12.1966 1.91539C12.4374 1.91539 12.6759 1.96317 12.8984 2.05536C13.1209 2.14758 13.3233 2.28279 13.4935 2.45315L13.6146 2.58661C13.7288 2.7257 13.8221 2.88134 13.8913 3.0482C13.9835 3.27071 14.0312 3.50916 14.0312 3.75002C14.0312 3.99088 13.9835 4.22934 13.8913 4.45184C13.8221 4.6187 13.7288 4.77434 13.6146 4.91343L13.4935 5.0469L13.4577 5.0827L13.3997 5.15106C13.3475 5.22331 13.3123 5.30679 13.2962 5.3952C13.2748 5.51314 13.2888 5.63515 13.3372 5.74481C13.3546 5.78417 13.3663 5.8256 13.373 5.86786C13.4192 5.94733 13.4827 6.01596 13.5599 6.06708C13.6574 6.13162 13.7717 6.16622 13.8887 6.16669H14C14.4862 6.16669 14.9524 6.35998 15.2962 6.7038C15.64 7.04761 15.8333 7.51379 15.8333 8.00002C15.8333 8.48625 15.64 8.95243 15.2962 9.29624C14.9524 9.64006 14.4862 9.83335 14 9.83335H13.942L13.8548 9.83986C13.7688 9.85284 13.6864 9.8846 13.6133 9.93296C13.5157 9.99757 13.4387 10.0897 13.3926 10.1973L13.3906 10.2018C13.3422 10.3115 13.3282 10.4335 13.3496 10.5515C13.371 10.6693 13.4273 10.7783 13.5111 10.864L13.5469 10.8998L13.668 11.0332C13.7822 11.1723 13.8755 11.328 13.9447 11.4948C14.0369 11.7173 14.0846 11.9558 14.0846 12.1966C14.0846 12.4375 14.0368 12.676 13.9447 12.8985C13.8755 13.0653 13.7821 13.221 13.668 13.36L13.5469 13.4935C13.3766 13.6639 13.1743 13.7991 12.9518 13.8913C12.7293 13.9835 12.4909 14.0313 12.25 14.0313C12.0091 14.0313 11.7707 13.9835 11.5482 13.8913C11.3813 13.8221 11.2257 13.7288 11.0866 13.6146L10.9531 13.4935L10.9173 13.4577L10.8489 13.3998C10.7767 13.3476 10.6932 13.3123 10.6048 13.2962C10.4869 13.2749 10.3649 13.2889 10.2552 13.3373L10.25 13.3399C10.1426 13.386 10.0509 13.4625 9.98632 13.5599C9.92176 13.6574 9.88718 13.7717 9.88671 13.8887V14C9.88671 14.4862 9.6934 14.9524 9.3496 15.2962C9.0058 15.64 8.53959 15.8333 8.05338 15.8334C7.56716 15.8334 7.10097 15.64 6.75715 15.2962C6.41333 14.9524 6.22004 14.4863 6.22004 14V13.9518L6.21158 13.8627C6.19618 13.7743 6.16066 13.6901 6.10806 13.6166C6.03803 13.5187 5.94038 13.4439 5.82746 13.4024C5.81759 13.3987 5.8078 13.3949 5.79817 13.3906C5.68849 13.3422 5.56652 13.3282 5.44856 13.3496C5.33071 13.3711 5.22169 13.4273 5.13606 13.5111L5.10025 13.5469C4.93002 13.7173 4.72769 13.8525 4.5052 13.9447C4.2827 14.0369 4.04423 14.0846 3.80338 14.0847C3.56254 14.0847 3.32404 14.0369 3.10155 13.9447C2.93471 13.8755 2.77904 13.7822 2.63996 13.668L2.5065 13.5469C2.33612 13.3767 2.20094 13.1743 2.10871 12.9518C2.0165 12.7293 1.96874 12.4909 1.96874 12.25C1.96874 12.0092 2.0165 11.7707 2.10871 11.5482C2.20094 11.3257 2.33612 11.1234 2.5065 10.9531L2.54231 10.9173C2.62606 10.8317 2.68233 10.7227 2.70377 10.6048C2.72515 10.4869 2.71113 10.3649 2.66275 10.2552L2.66015 10.25C2.61403 10.1426 2.53755 10.0509 2.44009 9.98635C2.367 9.93797 2.28454 9.90623 2.19856 9.89325L2.11132 9.88674H1.99999C1.51377 9.88674 1.04758 9.69343 0.703766 9.34963C0.359962 9.00583 0.16667 8.53962 0.166656 8.05341C0.166656 7.56719 0.359965 7.101 0.703766 6.75718C1.04758 6.41337 1.51376 6.22007 1.99999 6.22007H2.04817C2.16853 6.21726 2.28553 6.17813 2.38345 6.10809C2.48128 6.03806 2.55612 5.94041 2.59765 5.82749L2.60936 5.7982C2.65777 5.68852 2.67177 5.56655 2.65038 5.44859C2.62895 5.33074 2.57268 5.22172 2.48892 5.13609L2.45311 5.10028C2.28274 4.93005 2.14756 4.72772 2.05533 4.50523C1.96312 4.28273 1.91536 4.04426 1.91535 3.80341C1.91535 3.56257 1.96314 3.32407 2.05533 3.10158C2.14755 2.87912 2.28276 2.67675 2.45311 2.50653L2.58658 2.38544C2.72567 2.27123 2.88131 2.17791 3.04817 2.10874C3.27068 2.01654 3.50913 1.96877 3.74999 1.96877C3.99085 1.96877 4.2293 2.01654 4.45181 2.10874C4.6743 2.20097 4.87663 2.33615 5.04686 2.50653L5.08267 2.54234C5.16829 2.62609 5.27734 2.68236 5.39517 2.7038C5.51311 2.72518 5.63512 2.71116 5.74478 2.66278L5.79361 2.6439C5.81786 2.63611 5.8427 2.63033 5.86783 2.62632C5.94718 2.58013 6.01599 2.51722 6.06705 2.44012C6.13123 2.34314 6.16582 2.22958 6.16666 2.1133V2.00002C6.16666 1.51379 6.35995 1.04761 6.70377 0.703796C7.04758 0.35998 7.51376 0.166687 7.99999 0.166687C8.48622 0.166687 8.9524 0.35998 9.29621 0.703796C9.64003 1.04761 9.83332 1.51379 9.83332 2.00002V2.05796Z"
              fill="#00002B"
            />
          </g>
          <defs>
            <clipPath id="clip0_3374_397">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </MenuItem.Icon>
      <MenuItem.Label>
        <FormattedMessage id="MenuItem.Settings" />
      </MenuItem.Label>
    </MenuItem>
  );
}

function Logout({
  isListItem,
  className,
}: {
  className?: {icon?: string; label?: string};
  isListItem?: ItemProps['isListItem'];
}) {
  return (
    <MenuItem isListItem={isListItem}>
      <MenuItem.Icon className={className?.icon}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M1.5 12.667V3.33301C1.50009 2.84689 1.69337 2.38085 2.03711 2.03711C2.38085 1.69337 2.84689 1.50009 3.33301 1.5H6C6.27614 1.5 6.5 1.72386 6.5 2C6.5 2.27614 6.27614 2.5 6 2.5H3.33301C3.11211 2.50009 2.90034 2.58794 2.74414 2.74414C2.58794 2.90034 2.50009 3.11211 2.5 3.33301V12.667C2.50009 12.8879 2.58794 13.0997 2.74414 13.2559C2.90034 13.4121 3.11211 13.4999 3.33301 13.5H6C6.27614 13.5 6.5 13.7239 6.5 14C6.5 14.2761 6.27614 14.5 6 14.5H3.33301C2.84689 14.4999 2.38085 14.3066 2.03711 13.9629C1.69337 13.6192 1.50009 13.1531 1.5 12.667Z"
            fill="#00002B"
          />
          <path
            d="M10.3132 4.31315C10.5084 4.11789 10.8249 4.11789 11.0202 4.31315L14.3532 7.64616C14.5485 7.84142 14.5485 8.15793 14.3532 8.35319L11.0202 11.6872C10.825 11.8822 10.5084 11.8822 10.3132 11.6872C10.1179 11.492 10.1181 11.1754 10.3132 10.9801L13.2926 7.99967L10.3132 5.02018C10.1179 4.82492 10.1179 4.50841 10.3132 4.31315Z"
            fill="#00002B"
          />
          <path
            d="M14 7.5C14.2761 7.5 14.5 7.72386 14.5 8C14.5 8.27614 14.2761 8.5 14 8.5H6C5.72386 8.5 5.5 8.27614 5.5 8C5.5 7.72386 5.72386 7.5 6 7.5H14Z"
            fill="#00002B"
          />
        </svg>
      </MenuItem.Icon>
      <MenuItem.Label className={className?.label}>
        <FormattedMessage id="MenuItem.Logout" />
      </MenuItem.Label>
    </MenuItem>
  );
}

function Accounts({isListItem, numberOfApplications}: AccountsItemProps) {
  return (
    <MenuItem isListItem={isListItem}>
      <MenuItem.Icon className="relative">
        <MenuItem.New value={numberOfApplications} />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M0.833328 12.6667V3.33333C0.833328 2.8471 1.02662 2.38093 1.37044 2.03711C1.71425 1.69329 2.18043 1.5 2.66666 1.5H5.99999C6.16717 1.5 6.32328 1.58356 6.41601 1.72266L7.60091 3.5H13.3333C13.8196 3.5 14.2857 3.69329 14.6296 4.03711C14.9734 4.38093 15.1667 4.8471 15.1667 5.33333V12.6667C15.1667 13.1529 14.9734 13.6191 14.6296 13.9629C14.2857 14.3067 13.8196 14.5 13.3333 14.5H2.66666C2.18043 14.5 1.71425 14.3067 1.37044 13.9629C1.02662 13.6191 0.833328 13.1529 0.833328 12.6667ZM1.83333 12.6667C1.83333 12.8877 1.92119 13.0996 2.07747 13.2559C2.23375 13.4121 2.44565 13.5 2.66666 13.5H13.3333C13.5543 13.5 13.7662 13.4121 13.9225 13.2559C14.0788 13.0996 14.1667 12.8877 14.1667 12.6667V5.33333C14.1667 5.11232 14.0788 4.90042 13.9225 4.74414C13.7662 4.58786 13.5543 4.5 13.3333 4.5H7.33333C7.16615 4.5 7.01005 4.41644 6.91731 4.27734L5.73242 2.5H2.66666C2.44565 2.5 2.23375 2.58786 2.07747 2.74414C1.92119 2.90042 1.83333 3.11232 1.83333 3.33333V12.6667Z"
            fill="#00002B"
          />
        </svg>
      </MenuItem.Icon>
      <MenuItem.Label>
        <FormattedMessage id="MenuItem.Accounts" />
      </MenuItem.Label>
    </MenuItem>
  );
}

Item.HomeButton = HomeButton;
Item.MenuButton = MenuButton;
Item.Admin = Admin;
Item.Archive = Archive;
Item.Invoice = Invoice;
Item.Search = Search;
Item.Inbox = Inbox;
Item.Settings = Settings;
Item.Logout = Logout;
Item.Accounts = Accounts;

export default Item;
